import {GuestDetails} from '../guestDetails';
import {ApiError} from '../../core/redux/api/apiError';
import ModalView, {ModalContent} from '../../layout/modal/ModalView';
import {MODAL_SIZE} from '../../layout/modal/modalSize';
import ModalTitleHeader from '../../layout/modal/ModalTitleHeader';
import {AddCommentForm} from './AddCommentForm';
import {getErroredAddCommentHistory, getLoadingAddCommentHistory, validateAddGuestCommentsSubmission} from './module';
import {fullName} from '../module';
import {useEffect, useState} from 'react';
import {addGuestCommentAction} from './addGuestCommentAction';
import {useDispatch, useSelector} from 'react-redux';
import {IAppState} from '../../core/redux/IAppState';
import {isNilOrEmpty} from '../../language/module';
import addCommentIcon from '../../assets/icons/addComment.svg';
import { getResource } from '../../language/resources/getResource';


type Props = {
  guestId: string;
  guest?: GuestDetails;
  addGuestComment?: (subject: string, comments: string) => void;
  loadingSubmit?: boolean;
  errorSubmit?: ApiError;
  onDismiss: () => void;
};

/**
 * AddGuestCommentModal: a component that shows a form for the operatorId to add comments for a specific guest for other
 * agents to read when they look at the same guest.
 *
 * PureComponent: true
 * Connected to Redux: true
 */
export const AddGuestCommentModal = (props: Props) => {
  const [error, setError] = useState<string | undefined>(undefined);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const dispatch = useDispatch();
  const addGuestComment = (subject: string, comments: string) => dispatch(addGuestCommentAction(props.guestId, subject, comments));
  const {guest, loadingSubmit, errorSubmit, resources} = useSelector((state: IAppState) => ({
    guest: state.guests.get(props.guestId),
    loadingSubmit: !!getLoadingAddCommentHistory(state, props.guestId),
    errorSubmit: getErroredAddCommentHistory(state, props.guestId),
    resources: state.locale
  }))

  const { onDismiss } = props

  useEffect(() => {
    if (loadingSubmit) {
      setIsSubmitting(true);
    }

    if (isSubmitting && !loadingSubmit) {
      if (errorSubmit) {
        setError(errorSubmit.errorMsg);
      } else {
        onDismiss();
      }
      setIsSubmitting(false);
    }
  }, [loadingSubmit, errorSubmit, isSubmitting, onDismiss]);

  const onSubmit = (subject: string, comments: string) => {
    const error = validateAddGuestCommentsSubmission(resources, subject, comments);

    if (!isNilOrEmpty(error)) {
      setError(error);
    } else {
      addGuestComment(subject, comments);
    }
  }


  return (
    <ModalView
      size={MODAL_SIZE.SMALL}
      onDismiss={props.onDismiss}>
        <ModalTitleHeader resources={resources} heading={getResource(resources, 'ADD_COMMENT_ADD_COMMENT')} icon={addCommentIcon} onDismiss={props.onDismiss}/>
      <ModalContent>
        <AddCommentForm guestName={fullName(guest)}
                        isLoading={loadingSubmit}
                        error={error}
                        onSubmit={onSubmit}/>
      </ModalContent>
    </ModalView>
  );
}